import { render, staticRenderFns } from "./Newsliste.vue?vue&type=template&id=a9b48db6"
import script from "./Newsliste.vue?vue&type=script&lang=js"
export * from "./Newsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports